import { useEffect, useState } from "react";
import authorizedCall from "features/common/utils/authorizedCall";
import {
  EntityModelTimestampDto,
  PagedModelEntityModelTimestampDto,
  TimestampControllerService,
} from "openapi";
import { useUserGrantsContext } from "features/user/hooks/useUserGrantsContext";

export const useFileTs = () => {
  const [fileTsList, setFileTsList] = useState<EntityModelTimestampDto[]>([]);
  const [fileTsIsFetching, setFileTsIsFetching] = useState(false);
  const [fileTsError, setFileTsError] = useState("");
  const { userGrants } = useUserGrantsContext();

  const getFileTs = () => {
    setFileTsError("");
    setFileTsIsFetching(true);
    authorizedCall(TimestampControllerService.getFileTs, {}, true)
      .then((data: PagedModelEntityModelTimestampDto) => {
        setFileTsIsFetching(false);
        const tsList = data._embedded?.entities ?? [];
        setFileTsList(tsList);
      })
      .catch((error) => {
        setFileTsIsFetching(false);
        setFileTsError(error?.body?.message || error?.message);
      });
  };

  useEffect(() => {
    userGrants && getFileTs();
  }, [userGrants]);

  const refetchFileTs = () => getFileTs();

  return {
    fileTsList,
    fileTsIsFetching,
    fileTsError,
    getFileTs,
    refetchFileTs,
  };
};
